import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface DijuPendingAction {
  confirmationToken: string;
  roleName: string;
  permissionName: string;
  action: 'enable' | 'disable';
}

export interface DijuQueryResponse {
  reply: string;
  conversationId: string;
  pendingAction: DijuPendingAction | null;
}

export interface DijuConfirmResponse {
  success: boolean;
  message: string;
}

const CONVERSATION_ID_KEY = 'diju_conversation_id';

@Injectable({ providedIn: 'root' })
export class DijuChatService {
  private http = inject(HttpClient);
  private url = `${environment.rpsApiUrl}/api/rps/diju`;

  // Generated once per browser session. The server never trusts this for identity —
  // it only uses it to key conversation state under the authenticated user.
  getConversationId(): string {
    let id = sessionStorage.getItem(CONVERSATION_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(CONVERSATION_ID_KEY, id);
    }
    return id;
  }

  query(message: string) {
    return this.http.post<DijuQueryResponse>(`${this.url}/query`, {
      message,
      conversationId: this.getConversationId()
    });
  }

  confirm(confirmationToken: string) {
    return this.http.post<DijuConfirmResponse>(`${this.url}/confirm`, { confirmationToken });
  }
}
